(() => {
  if(window.FCM_PURCHASE_READY)return;
  window.FCM_PURCHASE_READY=true;
  const confirmed=new Set();
  const choices=new Map();
  const isSize=el=>/^(talla|size)$/i.test(el.dataset.optionName||'');
  function init(){
    document.querySelectorAll('[data-fcm-component-choice]').forEach(el=>{const key=el.getAttribute('form')+'|'+el.name;if(choices.has(key)&&[...el.options].some(o=>o.value===choices.get(key)&&!o.disabled))el.value=choices.get(key);});
    document.querySelectorAll('variant-picker').forEach(picker=>{
      if(picker.dataset.fcmInitialized)return;
      picker.dataset.fcmInitialized='true';
      const radios=[...picker.querySelectorAll('input[data-option-name]')].filter(isSize);
      if(!radios.length)return;
      if(!confirmed.has(picker.dataset.productId)){
        radios.forEach(el=>{el.checked=false;el.dataset.currentChecked='false';el.dataset.previousChecked='false';});
        const hint=document.createElement('p');hint.dataset.fcmChooseSize='';hint.setAttribute('role','status');hint.textContent='Elige tu talla antes de agregar al carrito.';picker.prepend(hint);
      }
    });
  }
  document.addEventListener('click',event=>{
    const el=event.target;
    if(el instanceof HTMLInputElement && isSize(el)&&el.getAttribute('aria-disabled')!=='true'){
      const picker=el.closest('variant-picker');if(picker){confirmed.add(picker.dataset.productId);picker.querySelector('[data-fcm-choose-size]')?.remove();}
    }
  },true);
  document.addEventListener('change',event=>{const el=event.target;if(el.matches?.('[data-fcm-component-choice]'))choices.set(el.getAttribute('form')+'|'+el.name,el.value);});
  window.FCM_VALIDATE_PURCHASE=form=>{
    const section=form.closest('.shopify-section');
    const productId=form.closest('product-form-component')?.dataset.productId;
    const picker=[...section?.querySelectorAll('variant-picker')||[]].find(p=>p.dataset.productId===productId);
    if(picker&&[...picker.querySelectorAll('input[data-option-name]')].some(isSize)&&!confirmed.has(picker.dataset.productId)){
      picker.querySelector('[data-fcm-choose-size]')?.scrollIntoView({block:'center'});picker.querySelector('input[data-option-name="Talla"]')?.focus();return false;
    }
    if(!form.reportValidity())return false;
    return true;
  };
  init();new MutationObserver(init).observe(document.body,{childList:true,subtree:true});
})();
